import React from 'react'
import { makeStyles } from '@material-ui/core'
import moment from 'moment-timezone'
import classnames from 'classnames'
import CheckCircle from '@material-ui/icons/CheckCircle'
import Tooltip from '@paintscout/ui/components/Tooltip'
import { useUser } from '../../providers/UserProvider'

export interface ReadCheckProps {
  readAt?: number | string | false
}

const useStyles = makeStyles(
  (theme) => ({
    checkCircle: {
      fontSize: '1rem !important',
      marginLeft: theme.spacing(0.5),
      verticalAlign: 'middle',
      cursor: 'pointer'
    }
  }),
  {
    name: 'ReadCheck'
  }
)

/**
 * The "Read" checkmark shown on read message activities. Tapping/hovering it opens a
 * "Read: <time>" tooltip (the shared Tooltip handles touch-tap + keeps the popover on
 * screen on iPad/Safari). Renders nothing unless there's a logged-in user and the message
 * has been read.
 */
export default function ReadCheck({ readAt }: ReadCheckProps) {
  const classes = useStyles({})
  const { user } = useUser()

  if (!user || !readAt) {
    return null
  }

  const readTime = moment(readAt).format('MMM D hh:mma')

  return (
    <Tooltip content={`Read: ${readTime}`} hideIcon disableWrapper placement="top">
      <CheckCircle
        className={classnames('no-redirect', classes.checkCircle)}
        onClick={(e) => {
          // Keep the surrounding ActivityLink from navigating to the estimate when the
          // checkmark is tapped (the `no-redirect` class is what ActivityLink checks for).
          e.preventDefault()
          e.stopPropagation()
        }}
      />
    </Tooltip>
  )
}
